<template>
  <div id="app">
    <div class="wrapper" v-if="!orderComplete">
      <div class="form">
        <div class="portability-container no-uniform">
          <div class="extra-opts">
            <div class="formBlock sim-container">
              <div class="blockTitle">Sim Card</div>
              <div>
                <div class="radioBlock inline">
                  <div class="radio">
                    <label>
                      <span class="input icon" style="margin-top: -5px">
                        <input
                          class=""
                          type="radio"
                          :name="'ko_unique'"
                          @click="portability = false"
                        />
                      </span>
                      <span>{{ messages["qsim.sim.radio2"] }}</span>
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <span class="input icon" style="margin-top: -5px">
                        <input
                          class=""
                          type="radio"
                          :name="'ko_unique'"
                          @click="portability = true"
                        />
                      </span>
                      <span>{{ messages["qsim.sim.radio1"] }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Order
          :messages="messages"
          :atgProducts="atgProducts"
          v-if="portability === false"
        />
        <Portability
          :messages="messages"
          :counties="counties"
          :identificationDocuments="identificationDocuments"
          :prepaidProducts="prepaidProducts"
          @orderComplete="completeOrder"
          v-if="portability === true"
        />
        <p class="recaptcha-disclaimer">
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a>
          and
          <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a>
          apply.
        </p>
      </div>
    </div>
    <ThankYou :messages="messages" :product="product" v-else />
  </div>
</template>

<script>
import Order from "./components/Order";
import Portability from "./components/Portability.vue";
import ThankYou from "./components/ThankYou";

export default {
  name: "App",
  components: {
    Order,
    Portability,
    ThankYou,
  },
  data: function () {
    return {
      portability: "",
      messages: {},
      identificationDocuments: [],
      prepaidProducts: [],
      counties: [],
      atgProducts: [],
      product: {},
      orderComplete: false,
    };
  },
  beforeMount: function () {
    var locale = document.getElementsByTagName("body")[0].dataset.locale;
    if (locale == "en_US") {
      this.locale = "en";
    } else {
      this.locale = "gr";
    }
    this.axios
      .get(
        `/sites/Satellite/?pagename=fetchVueTranslationsEntry&ciKey=qonlinesimorder&locale=${locale}`
      )
      .then((response) => {
        this.messages = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    formInputInit();

    var pload = {};

    var caller = {
      callingSystem: "WINDweb",
      salesCode: "",
      username: "username",
      channel: "Q",
    };

    caller.locale = document.getElementsByTagName("body")[0].dataset.locale
      ? document.getElementsByTagName("body")[0].dataset.locale
      : "el_GR";

    pload.caller = caller;

    this.axios
      .post(`/apiv2/contentrepository/getPrepaidCategories/`, pload)
      .then((response) => {
        if (response.data.errorLevel == 0) {
          for (var j = 0; j < response.data.categories.length; j++) {
            if (
              response.data.categories[j].id == 1526318531913 ||
              response.data.categories[j].id == 1526318531941
            ) {
              this.prepaidProducts = response.data.categories[j].PrepaidProducts;
            }
          }
        } else {
          console.log(
            "getPrepaidCategories responded with error " + response.data.errorMessage
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post(`/apiv2/contentrepository/getSimCardsInformation/`, pload)
      .then((response) => {
        if (response.data.errorLevel == 0) {
          if (response.data.simInfo) {
            this.atgProducts = response.data.simInfo;
          }
        } else {
          console.log(
            "getSimCardsInformation responded with error " + response.data.errorMessage
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .get(`/${this.locale}/getCounties/`)
      .then((response) => {
        this.counties = response.data.counties;
      })
      .catch((error) => {
        console.log(error);
      });

    this.axios
      .post("/apiv2/contentrepository/getIdentificationDocuments/", pload)
      .then((response) => {
        if (response.data.errorLevel == 0) {
          for (var doc = 0; doc < response.data.documents.length; doc++) {
            this.identificationDocuments.push(response.data.documents[doc].title);
          }
        } else {
          console.log(
            "getIdentificationDocuments responded with error " +
              response.data.errorMessage
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    completeOrder(data) {
      this.orderComplete = true;
      document.getElementsByClassName("intro")[3].scrollIntoView();
      this.product = data;
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none;
}

p.recaptcha-disclaimer {
  color: #ada8a0;
  font-size: 0.9rem;
  line-height: 1.3rem;
  padding: 1.3rem 0;
}

p.recaptcha-disclaimer a {
  color: #ada8a0;
  text-decoration: underline;
}
</style>
